import { DateTime } from "luxon";

export const checkIfStringIsDate = (dateString) => {
	return DateTime.fromISO(dateString).isValid;
};
